import { createFileRoute } from '@tanstack/react-router'
import { OpsInboxTabContent } from '@/pages/OpsInbox'

export const Route = createFileRoute('/_authenticated/ops-inbox/all')({
  component: () => <OpsInboxTabContent filterType="all" />,
})
